import { render, staticRenderFns } from "./formStep5.vue?vue&type=template&id=052a4cc5&"
import script from "./formStep5.vue?vue&type=script&lang=js&"
export * from "./formStep5.vue?vue&type=script&lang=js&"
import style0 from "./formStep5.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports